import { useCallback } from "react";
import { useStatsigClient } from "@statsig/react-bindings";

export type OnboardingEvent =
  | "onboarding_step_view"
  | "onboarding_skip"
  | "onboarding_import_click"
  | "onboarding_import_done"
  | "onboarding_import_failed";

// Each step's views, skips and import clicks, so the new onboarding can be
// compared with the old one.
export const useOnboardingTracking = () => {
  const { logEvent } = useStatsigClient();

  return useCallback(
    (event: OnboardingEvent, metadata: Record<string, string> = {}) => {
      try {
        logEvent(event, undefined, metadata);
      } catch (error) {
        // Tracking must never break the onboarding.
        console.error("Statsig Log Error:", error);
      }
    },
    [logEvent]
  );
};
